import { z } from 'zod';

export const SecretReference = z.object({
  secretId: z.string(),
});

export type SecretReference = z.infer<typeof SecretReference>;
